import React from 'react';

export const ProcessingVisual = ({ origin }) => {
  if(origin === "China"){
    return(<video className="il-add" data-beta-flow="true" src="/img/processing/processing-cn-upper.mp4" preload="true" autoPlay={true} loop={true} muted={true}></video>);	    	     
  }else{
   return(<video className="il-add" data-beta-flow="true" src="/img/processing/AF_D-ir_Processing_540.mp4" preload="true" autoPlay={true} loop={true} muted={true}></video>);
  }  
};